import React, { useCallback, useState, useEffect } from 'react'
import { store } from "@root/store/index";
import { Select, Form, Button, Table, Input, message } from 'antd';
import { SearchOutlined, RedoOutlined } from '@ant-design/icons';
import { getOutlog, exportOutlog } from "@root/common/service";
import axios from 'axios';

import type { ColumnsType } from 'antd/es/table';
import "./_style.scss"

const { Option } = Select;
interface DataType {
  key: number|string;
  nickName: string;
  sex: number|string;
  identityNumber: number|string;
  phonenumber: number|string;
  subjectId: number|string;
  baseHealthTitle: number|string;
  createTime: number|string;
}

function Index() {

  const columns: ColumnsType<DataType> = [
    {
      title: '序号',      
      render:(text, record, index) => `${index + 1}`,
    },
    {
      title: "姓名",
      dataIndex: "nickName",
      key: "nickName",
    },
    {
      title: "性别",
      dataIndex: "sex",
      key: "sex",
      render: (_: any, record: any) => {
        return <span>{_ === "0" ? "男" : "女"}</span>;
      },
    },
    {
      title: "身份证号码",
      dataIndex: "identityNumber",
      key: "identityNumber",
    },
    {
      title: "手机号",
      dataIndex: "phonenumber",
      key: "phonenumber",
    },
    {
      title: "学科",
      dataIndex: "subjectId",
      key: "subjectId",
      render: (_: any, record: any) => {
        const item = subjectIdArr.find((item: any) => item.id === _);
        return <span>{item ? item.name : ""}</span>;
      },
    },
    {
      title: "职称",
      dataIndex: "baseHealthTitle",
      key: "baseHealthTitle",
      render: (_: any, record: any) => {
        // eslint-disable-next-line eqeqeq
        const item = titleData.find((item: any) => item.id == _);
        return <span>{item ? item.name : ""}</span>;
      },
    },
    {
      title: "学员状态",
      dataIndex: "status",
      key: "status",
      render: (_: any) => {
        return <span>已调出</span>;
      },
    },
    {
      title: "操作时间",
      dataIndex: "createTime",
      key: "createTime",
    },
  ];
  
  // const data: DataType[] 
  

  const [form1] = Form.useForm();
  const [data, setData] = useState<DataType[]>();
  const [titleData, setTtitleData] = useState<any>([])
  const [subjectIdArr, setSubjectIdArr] = useState<any>([])
  // const [userInfo, setUserInfo] = useState<any>()


  const getAll = async()=>{
    const {rows} = await getOutlog(`instituteId=${store.getState().userInfo.instituteId}`);
    rows.forEach((el: any)=>{
      el.key = el.id
    })
    setData(rows)
  }
    
  useEffect(()=>{
    console.log(store.getState());
    setTtitleData(store.getState().directionaries.titleData)
    setSubjectIdArr(store.getState().directionaries.subjectData)
    // setUserInfo(store.getState().userInfo.instituteId)
    getAll()
  },[])

  const handleChange = useCallback((e: any)=>{
    console.log(e);
  },[])
  const onFinish = useCallback((e: any)=>{
    console.log(e);
    const keys: Array<string> = Object.keys(e)
    const values = Object.values(e)
    const arr: any = values.reduce(function(r,el,i){
      if(!!el){
        r+=`${keys[i]}=${el}&`
      }
      return r
    },`instituteId=${store.getState().userInfo.instituteId}&`)
    console.log(arr); 
    const getOne = async()=>{
      const {rows} = await getOutlog(`${arr.slice(0,-1)}`);      
      setData(rows)
    }
    getOne()
  },[])
  const onFinishFailed = useCallback((e: any)=>{
    console.log(e);
  },[])
  const onReset = useCallback(()=>{
    form1.resetFields();
    getAll()
  },[form1])
  
  const exportLog = useCallback(() =>{
    console.log(form1.getFieldsValue());
    const formData: any = form1.getFieldsValue()
    const keys = Object.keys(formData)
    const values = Object.values(formData)
    const obj: any = values.reduce(function(r: any,el,i){
      if(!!el){
        r[keys[i]] = el
      }
      return r
    },{})


    const { userInfo: { access_token, instituteId } } = store.getState();
    // const config = { headers: {'Content-Type': 'application/json;charset=UTF-8', 'Authorization': `Bearer ${access_token}`}};
    axios({
      method: 'post',
      url: `/dev-api/system/outlog/export?instituteId=${instituteId}`,
      data: obj,
      responseType: 'blob',
      headers: {'Content-Type': 'application/json;charset=UTF-8', 'Authorization': `Bearer ${access_token}`}
    }).then((res)=>{
      console.log(res);
      const b = new Blob([res.data],{type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'})
      console.log(b);
      let a = document.createElement('a');
      a.href = URL.createObjectURL(b)
      a.setAttribute('download', 'excel.xlsx');
      a.click();
      URL.revokeObjectURL(a.href); 
      a.remove()
    })
  },[form1])

  return (
    <div style={{padding: '15px', background: '#fff'}}>
      <div className='top'>
        <Form
          name="outLogSet"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          layout="inline"
          form={form1}
        >
          <Form.Item label="姓名" name="nickName" >
            <Input allowClear key={'nickName'}/>
          </Form.Item>

          <Form.Item label="证件号" name="identityNumber" >
            <Input allowClear key={'identityNumber'}/>
          </Form.Item>

          <Form.Item label="手机号" name="phonenumber" >
            <Input allowClear key={'phonenumber'}/>
          </Form.Item>

          <Form.Item
            label="学科"
            name="subjectId"
          >
            <Select
              placeholder="请选择学科"
              onChange={handleChange}
              allowClear
              style={{ width: 120 }}
            >
              {subjectIdArr.map((e: any, i: number)=>{
                return <Option value={e.id} key={i}>{e.name}</Option>
              })} 
            </Select>
          </Form.Item>

          <Form.Item
            label="职称"
            name="baseHealthTitle"
          >
            <Select
              placeholder="请选择职称"
              onChange={handleChange}
              allowClear
              style={{ width: 120 }}
            >
              {titleData.map((e: any, i: number)=>{
                return <Option value={e.id} key={i}>{e.name}</Option>
              })} 
            </Select>
          </Form.Item>

          <Form.Item style={{marginLeft: '30px'}}>
            <Button  type="primary" htmlType="submit"><SearchOutlined />查询</Button>
            <Button  type="primary" onClick={onReset} style={{marginLeft: '15px'}} ><RedoOutlined />重置</Button>
          </Form.Item>
        </Form>
      </div>

      <div className='midBtn'>
        <Button type="primary" onClick={exportLog}>导出</Button>
      </div>

      <div>
        <Table bordered columns={columns} dataSource={data} />
      </div>
    </div>
  )
}

export default Index